<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("terminal") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <!-- <div class="title is-5">{{ $t("system terminal") }}</div> -->
        <!-- <label class="label">{{ $t("input") }}</label> -->
        <div class="content">
          <pre><ul ref="console"></ul></pre>
        </div>
        <div class="field has-addons">
          <div class="control is-expanded">
            <input
              class="input"
              type="text"
              style="
                font-family: 'Courier New', Courier, monospace;
                color: chartreuse;
              "
              v-model="meta.input"
              ref="input"
            />
          </div>
          <div class="control">
            <div
              class="button is-info"
              :data-tooltip="$t('execute')"
              @click="execute_command"
            >
              <span class="icon">
                <i class="fa fa-bolt"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="tags">
          <span
            class="tag"
            v-for="(command, index) in local_commands"
            :key="index"
          >
            {{ command.command }}
          </span>
        </div>
        <!-- <div class="field">
          <label class="label">{{ $t("output") }}</label>
          <div class="control">
            <textarea class="textarea" v-model="meta.output"></textarea>
          </div>
        </div> -->

        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { post, /* generate_error_message_text, */ format_time } from "@/utils";
import moment from "moment";

export default {
  name: "TerminalModal",
  data() {
    let v = this;
    return {
      is_shown: false,
      meta: {},
      error: "",
      local_commands: [
        {
          command: "clear",
          action: () => {
            v.$refs.console.innerHTML = "";
            v.meta.input = "";
            v.$refs.input.focus();
          },
        },
        {
          command: "exit",
          action: () => {
            v.close_modal();
          },
        },
        {
          command: "cb",
          action: () => {
            window
              .jQuery(this.$refs.console)
              .append(
                `<li>[${format_time(moment())}] ${this.$t(
                  "custom build signal sent"
                )}</ li>`
              );
            v.$emit("system_signal", "make_custom_build");
          },
        },
        {
          command: "rs",
          action: () => {
            window
              .jQuery(this.$refs.console)
              .append(
                `<li>[${format_time(moment())}] ${this.$t(
                  "reset signal sent"
                )}</ li>`
              );
            v.$emit("system_signal", "reset_system");
          },
        },
        {
          command: "update",
          action: () => {
            window
              .jQuery(this.$refs.console)
              .append(
                `<li>[${format_time(moment())}] ${this.$t(
                  "update signal sent"
                )}</ li>`
              );
            v.$emit("system_signal", "update_system");
          },
        },
        {
          command: "models",
          action: () => {
            window
              .jQuery(this.$refs.console)
              .append(
                `<li>[${format_time(moment())}] ${this.$t(
                  "generate models signal sent"
                )}</ li>`
              );
            v.$emit("system_signal", "generate_models");
          },
        },
        {
          command: "build",
          action: () => {
            window
              .jQuery(this.$refs.console)
              .append(
                `<li>[${format_time(moment())}] ${this.$t(
                  "build signal sent"
                )}</ li>`
              );
            v.$emit("system_signal", "build");
          },
        },
      ],
    };
  },
  computed: {},
  props: {},
  methods: {
    show_modal() {
      let v = this;
      v.is_shown = true;
      v.set_initial_state();
      setTimeout(() => {
        v.$refs.input.focus();
      }, 500);

      window.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          v.execute_command();
        }
      });
    },
    close_modal() {
      let v = this;
      v.is_shown = false;
      v.set_initial_state();
    },
    set_initial_state() {
      this.meta = {};
      this.error = "";
      this.$refs.console.innerHTML = "";
      window.removeEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          this.execute_command();
        }
      });
    },
    execute_command() {
      let v = this;
      v.error = "";

      let lowercased_input = v.meta.input.toLowerCase();
      let target_local_command = v.local_commands.find(
        (command) => command.command.toLowerCase() == lowercased_input
      );
      if (target_local_command) {
        target_local_command.action();
        v.meta.input = "";
        v.$refs.input.focus();
        return;
      } else {
        post("/core/terminal", { command: v.meta.input })
          .then((response) => {
            if (!v.meta.output) v.meta.output = "";
            window
              .jQuery(v.$refs.console)
              // .prepend(`<li>[${format_time(moment())}] ${response.stdout}</ li>`);
              .append(
                `<li>[${format_time(moment())}] ${response.stdout}</ li>`
              );
            v.meta.input = "";
            v.$refs.input.focus();
          })
          .catch((error) => {
            // console.log("error", error);
            window
              .jQuery(v.$refs.console)
              .prepend(`<li>[${format_time(moment())}] ${error.data}</ li>`);
            v.meta.input = "";
            v.$refs.input.focus();
          });
      }
    },
  },
  mounted() {},
};
</script>
<style></style>
